<template>
  <div class="options-module">
    <checkout-time-selection ref="checkout"/>
    <div class="options-module_header" v-if="false">
      <v-radio-group
        class="options-module_header-toggle"
        v-model="isSingletonValue"
        row
      >
        <v-radio
          label="Заполнить для всех"
          :value="1"
        ></v-radio>
        <v-radio
          label="Заполнить для каждого гостя отдельно"
          :value="0"
        ></v-radio>
      </v-radio-group>
    </div>

    <div class="options-module_body">
      <div v-if="isSingletonValue">
        <options-form></options-form>
      </div>

      <div v-else>
        <v-expansion-panels
          v-model="panelIndex"
          focusable
          multiple
        >
          <v-expansion-panel
            v-for="guest in guestsList"
            :key="guest.id"
          >
            <v-expansion-panel-header
              color="#EAEAEA"
            >
              {{`${guest.secondName} ${guest.firstName}${!guest.isNoThirdName ? ' ' + guest.thirdName : ''}`}}
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div class="options-module_expansion-panel-inner">
                <options-form :guestId="guest.id"></options-form>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div
        class="options-module_additional"
        v-if="getAvilableServices.length > 0"
      >
        <span class="options-module_additional-title">Дополнительная услуга</span>

        <div class="options-module_additional-list">
          <!-- Парковка -->
          <v-form
            class="options-module_additional-item"
            v-if="getAvilableServices.find(o => o.name === `parking`)"
            @submit.prevent
            ref="parkingForm"
          >
            <div class="options-module_additional-item-inner">
              <div class="options-module_additional-item-checkbox">
                <v-checkbox
                  class="ui-checkbox"
                  v-model="isParkingSelected"
                >
                  <template v-slot:label>Парковка</template>
                </v-checkbox>
              </div>

              <!-- <span class="options-module_additional-item-name">Парковка</span> -->

              <div class="options-module_additional-item-fields">
                <ui-field label="Период" class="options-module_additional-item-field options-module_parking-period">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    v-model="parkingDatesMenu"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        label="Период"
                        readonly
                        solo
                        class="ui-input"
                        :value="dispParkingDates"
                        :disabled="!isParkingSelected"
                        :rules="isParkingSelected ? [rules.required] : []"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>$calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>

                    <v-date-picker
                      width="auto"
                      class="ui-datepicker"
                      locale="ru-ru"
                      no-title
                      range
                      :min="storeDateIn"
                      :max="storeDateOut"
                      v-model="parkingDates"
                      @change="onParkingDatesChange"
                      first-day-of-week="1"
                      :weekday-format="helpers.getWeekDay"
                    />
                  </v-menu>
                </ui-field>

                <ui-field label="Номер машины" class="options-module_additional-item-field options-module_parking-car-plate">
                  <v-text-field
                    solo
                    class="ui-input"
                    v-mask="parkingCarPlateMask"
                    v-model="parkingCarPlateValue"
                    @change="updateParkingCarPlate"
                    placeholder="Номер машины"
                    :disabled="!isParkingSelected"
                    :rules="isParkingSelected ? [rules.required, rules.carPlate] : []"
                    validate-on-blur
                  ></v-text-field>
                </ui-field>
              </div>

              <span class="options-module_additional-item-price">
                Сумма:
                <span class="options-module_additional-item-price-value">{{parkingData.data.totalPrice}} р</span>
              </span>
            </div>
          </v-form>

          <!-- Трансфер -->
          <v-form
            @submit.prevent
            class="options-module_additional-item"
            v-if="getAvilableServices.find(o => o.name === `transfer`)"
            ref="transferForm"
          >
            <div class="options-module_additional-item-inner">
              <div class="options-module_additional-item-checkbox">
                <v-checkbox
                  class="ui-checkbox"
                  v-model="isTransferSelected"
                >
                  <template v-slot:label>Трансфер<sup>*</sup></template>
                </v-checkbox>
              </div>

              <!-- <span class="options-module_additional-item-name">Трансфер<sup>*</sup></span> -->

              <div class="options-module_additional-item-fields">
                <ui-field label="Дата отправки" class="options-module_additional-item-field options-module_transfer-date">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    nudge-top="30px"
                    v-model="transferDateMenu"
                  >
                    <template v-slot:activator="{on}">
                      <v-text-field
                        v-on="on"
                        placeholder="Дата отправки"
                        solo
                        class="ui-input"
                        v-model="transferDate"
                        v-mask="'##.##.####'"
                        :rules="isTransferSelected ? [rules.required, rules.date] : []"
                        :disabled="!isTransferSelected"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>$calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>

                    <v-date-picker
                      width="auto"
                      class="ui-datepicker"
                      locale="ru-ru"
                      no-title
                      @change="(value) => {
                        let arr = value.split(`-`)
                        this.transferDate = `${arr[2]}.${arr[1]}.${arr[0]}`
                        this.transferDateMenu = false
                      }"
                      first-day-of-week="1"
                      :weekday-format="helpers.getWeekDay"
                    />
                  </v-menu>
                </ui-field>

                <ui-field label="Точка отправки" class="options-module_additional-item-field options-module_transfer-from">
                  <v-menu
                    offset-y
                    :close-on-content-click="false"
                    v-model="transferPointSuggestionsMenu"
                    nudge-top="30px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        solo
                        class="ui-input"
                        placeholder="Точка отправки"
                        v-model="transferPointValue"
                        @input="transferPointSuggestionsMenu = true"
                        ref="transferPoint"
                        @blur="onBlurTransferPoint"
                        :rules="isTransferSelected ? [rules.required] : []"
                        :disabled="!isTransferSelected"
                      />
                    </template>

                    <v-list>
                      <template v-if="transferPointSuggestions.length > 0">
                        <v-list-item
                          v-for="(item, i) in transferPointSuggestions"
                          :key="i"
                          @click="selectTransferPointSuggestion(item)"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-text="item.value" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                      <template v-else>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title v-text="'Неизвестный адрес'" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </ui-field>
              </div>

              <span class="options-module_additional-item-price">
                Сумма рассчитывается оператором
              </span>
            </div>

            <p class="options-module_additional-item-footnote">
              * - Услуга трансфера оказывается сторонней организацией.<br>
              С вами свяжутся по телефону. Если по какой-то причине с вами
              не связались, сообщите нам по номеру телефона <a href="tel:88001004554" class="ui-link">8 (800) 100 65 54</a>
            </p>
          </v-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters, mapActions } from 'vuex'
import { IMaskDirective } from 'vue-imask'
import Helpers from '@/helpers/Helpers'
import OptionsForm from '@/components/OptionsForm'
import CheckoutTimeSelection from "@/components/checkoutTimeSelection.vue";
export default {
  name: 'options-module',

  components: {
    OptionsForm,
    CheckoutTimeSelection
  },

  directives: {
    imask: IMaskDirective
  },

  data: () => ({
    panelIndex: [],
    parkingDates: [],
    parkingCarPlateValue: null,
    parkingCarPlateMask: 'L###LL###',
    parkingDatesMenu: false,
    transferDate: null,
    transferDateMenu: false,
    transferPointValue: '',
    transferPointSelected: '',
    transferPointSuggestionsMenu: false,
    transferPointSuggestions: [],
    rules: {
      required: v => !!v || `Обязательное поле`,
      date: value => {
        let pattern = /^\d{2}[./-]\d{2}[./-]\d{4}$/
        return pattern.test(value) || 'Неверный формат даты'
      },
      carPlate: v => {
        let pattern = /[А-Яа-я][0-9]{3}[А-Яа-я]{2}[0-9]{2,3}/
        return pattern.test(v) || `Неверный формат`
      }
    },
  }),

  methods: {
    ...mapActions({
      changeIsStepThreeSingleton: 'changeIsStepThreeSingleton',
      updateAllGuests: 'guestsModule/updateAllGuests',
      updateExtraService: 'extraServices/updateExtraService'
    }),

    updateParkingCarPlate(value) {
      if(value.length >= 8 && value.length <= 9) {
        this.updateExtraService({
          name: 'parking',
          data: { additional: value, }
        })
      } else {
        this.updateExtraService({
          name: 'parking',
          data: { additional: null, }
        })
      }
    },

    onParkingDatesChange() {
      this.parkingDatesMenu = false
    },

    selectTransferPointSuggestion(item) {
      this.transferPointValue = item.value

      if(+item.data.fias_level > 6) {
        this.transferPointSelected = item.value
        this.$refs.transferPoint.errorMessages = []
        this.$refs.transferPoint.error = false
        this.transferPointSuggestionsMenu = false
      } else {
        // console.log(this.$refs.transferPoint)
        this.$refs.transferPoint.errorMessages = ['Введено недостаточное значение']
        this.$refs.transferPoint.error = true
      }
    },

    onBlurTransferPoint() {
      if(this.transferPointValue === '') {
        this.transferPointSelected = ''
        this.updateExtraService({
          name: 'transfer',
          data: {
            additional: '',
          }
        })
      }
    },
  },

  computed: {
    ...mapState({
      isSingleton: state => state.isStepThreeSingleton,
      dictionaryExtraServices: state => state.dictionaries.extraServices,
      storeExtraServices: state => state.extraServices.list,
      storeDateIn: state => state.selection.dateIn,
      storeDateOut: state => state.selection.dateOut,
      storeSelectedCategoryId: state => state.selection.selectedCategoryId,
      // krasniyYarIds: state => state.dictionaries.krasniyYarIds,
    }),

    ...mapGetters({
      getGuestsFields: 'guestsModule/getGuestsFields',
      getCommonField: 'guestsModule/getCommonField',
      getAvilableServices: 'extraServices/getAvilable',
    }),

    helpers() {
      return Helpers
    },

    parkingData() {
      return this.storeExtraServices.find(obj => obj.name === 'parking')
    },

    transferData() {
      return this.storeExtraServices.find(obj => obj.name === 'transfer')
    },

    // isExtraServiceParkingExist() {
    //   let check = -1
    //   if(this.parkingData && this.krasniyYarIds.findIndex(id => id === this.storeSelectedCategoryId) === -1) {
    //     check = this.dictionaryExtraServices.findIndex(obj => obj.id === this.parkingData.id)
    //   }
    //   return (check === -1) ? false : true
    // },

    // isExtraServiceTransferExist() {
    //   let check = -1
    //   if(this.transferData) {
    //     check = this.dictionaryExtraServices.findIndex(obj => obj.id === this.transferData.id)
    //   }
    //   return (check === -1) ? false : true
    // },

    guestsList() {
      return this.getGuestsFields(['id', 'firstName', 'secondName', 'thirdName', 'isNoThirdName', 'guestType']).filter(obj => obj.guestType !== '2')
    },

    isSingletonValue: {
      get() {
        return this.isSingleton
      },
      set(value) {
        this.changeIsStepThreeSingleton(value)
      }
    },

    isParkingSelected: {
      get() {
        // return this.parkingData.cnt === 1 ? true : false
        return this.parkingData.data.isSelected
      },
      set(value) {
        // let cnt = value ? 1 : 0
        this.updateExtraService({
          name: 'parking',
          data: {
            // cnt: cnt,
            isSelected: value,
          }
        })
      }
    },

    dispParkingDates() {
      if(this.parkingData.data.dateStart && this.parkingData.data.dateEnd) {
        let ds = this.parkingData.data.dateStart.split('-')
        let de = this.parkingData.data.dateEnd.split('-')

        return `${ds[2]}.${ds[1]}.${ds[0]} - ${de[2]}.${de[1]}.${de[0]}`
      }
      return ''
    },

    isTransferSelected: {
      get() {
        return this.transferData.data.isSelected
      },
      set(value) {
        this.updateExtraService({
          name: 'transfer',
          data: {
            isSelected: value,
          }
        })
      }
    },

  },

  watch: {
    isSingleton(value) {
      if(value === 1) this.updateAllGuests({
        nutrition: this.getCommonField('nutrition'),
        cure: this.getCommonField('cure'),
      })
    },

    parkingDates(value) {
      if(this.getAvilableServices.find(o => o.name === `parking`) && value.length === 2) {
        let dateStart = null
        let dateStartObj = null
        let dateEnd = null
        let dateEndObj = null
        let pricePerDay = this.dictionaryExtraServices.find(obj => obj.id === this.parkingData.id).price

        if (new Date(value[0]) > new Date(value[1])) {
          dateStart = value[1]
          dateStartObj = new Date(value[1])
          dateEnd = value[0]
          dateEndObj = new Date(value[0])
        } else {
          dateStart = value[0]
          dateStartObj = new Date(value[0])
          dateEnd = value[1]
          dateEndObj = new Date(value[1])
        }

        // calc days cnt
        let daysCnt = ((dateEndObj - dateStartObj) / (1000 * 3600 * 24)) + 1
        // console.log(daysCnt)

        // calc price
        let totalPrice = (pricePerDay * (daysCnt - 1)).toFixed(2)
        // console.log(price)

        // update store
        this.updateExtraService({
          name: 'parking',
          data: {
            dateStart,
            dateEnd,
            // daysCnt,
            totalPrice,
          }
        })
      }
    },

    transferDate(value) {
      if(this.rules.date(value) === true) {
        let arr = value.split(`.`)
        this.updateExtraService({
          name: 'transfer',
          data: {
            dateStart: `${arr[2]}-${arr[1]}-${arr[0]}`,
            dateEnd: `${arr[2]}-${arr[1]}-${arr[0]}`,
          }
        })
      } else {
        this.updateExtraService({
          name: 'transfer',
          data: {
            dateStart: ``,
            dateEnd: ``,
          },
        })
      }
    },

    transferPointValue(val) {
      // console.log(val)

      // // Items have already been requested
      if (this.transferPointIsLoading) return

      this.transferPointIsLoading = true
      // Lazily load input items

      let headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": "Token 5963636dd2f4f559038b6b541f3d8514e37f7481",
      }

      axios
        .post(
          'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
          {
            query: val,
            count: 5
          },
          {
            headers
          }
        )
        .then(resp => {
          // console.log(resp)
          this.transferPointSuggestions = resp.data.suggestions
          // .reduce((acc, cur) => {
          //   acc.push(cur.value)

          //   return acc
          // }, [])
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.transferPointIsLoading = false
        })
    },

    transferPointSelected(val) {
      this.updateExtraService({
        name: 'transfer',
        data: {
          additional: val,
        }
      })
    }
  },

  mounted() {
    this.panelIndex = this.guestsList.reduce((a,c,i) => [...a, i], [])
    // присвоение дефолтных значений датам парковки
    this.parkingDates = [this.storeDateIn, this.storeDateOut]

    // присвоение номера машины парковки
    this.parkingCarPlateValue = this.parkingData.data.additional

    // присвоение значений полям трансфера из хранилища
    if(this.transferData.data.dateStart) {
      let arr = this.transferData.data.dateStart.split(`-`)
      this.transferDate = `${arr[2]}.${arr[1]}.${arr[0]}`
    }
    if(this.transferData.data.additional) {
      this.transferPointValue = this.transferData.data.additional
      this.transferPointSelected = this.transferData.data.additional
    }
  }
}
</script>

<style lang="sass">
.options-module_header
  border-top: 1px solid #8A8A8A
  border-bottom: 1px solid #8A8A8A
  margin-bottom: 30px
  padding: 20px 0

.options-module_expansion-panel-inner
  padding: 25px 30px 50px

.options-module_additional
  padding-top: 40px
  padding-bottom: 40px
  margin-top: 30px
  border-top: 1px solid #8A8A8A

.options-module_additional-title
  display: block
  margin-bottom: 30px
  font-weight: 700
  font-size: 1.125em
  color: #1A4745

.options-module_additional-item-inner
  width: 100%
  display: flex
  align-items: center
  // align-items: flex-end

.options-module_additional-item-checkbox
  padding-top: px-em(12)
  margin-right: px-em(20)
  width: px-em(260)

  .v-input--selection-controls .v-input__slot > .v-label,
  .v-input--selection-controls .v-radio > .v-label
    color: #696D74 !important
    font-weight: 400 !important
  //   display: none

.options-module_additional-item-name
  width: px-em(260)
  margin-right: px-em(20)

.options-module_additional-item-fields
  flex-grow: 1
  display: flex
  // margin-top: px-em(-24)
  margin-right: px-em(20)

.options-module_additional-item-field
  flex: 1 1 auto
  max-width: px-em(250)

  + .options-module_additional-item-field
    margin-left: px-em(20)

.options-module_additional-item-price
  // margin-left: auto

.options-module_additional-item-price-value
  font-weight: 700

.options-module_additional-item-footnote
  font-size: px-em(14)
  width: 100%
  padding: 0
  margin: 0

.v-application .options-module_additional-item-footnote
  padding: 0
  margin: 0

.options-module_parking-period
  max-width: px-em(308)

.options-module_parking-car-plate
  max-width: px-em(177)

.options-module_transfer-date
  max-width: px-em(190)

.options-module_transfer-from
  max-width: px-em(300)

@media screen and (max-width: $mobile-breakpoint)
  .options-module_header-toggle
    margin-top: 0

    .v-radio + .v-radio
      margin-top: px-em(10,12)

  .options-module_expansion-panel-inner
    padding: px-em(20,12) px-em(12,12) px-em(10,12)

  .options-module_additional
    padding-bottom: 0
    padding-top: px-em(20,12)
    margin-top: px-em(10,12)

  .options-module_additional-title
    margin-bottom: 20px

  .options-module_additional-item
    flex-direction: column
    align-items: flex-start

  .options-module_additional-item-name
    order: 0
    margin-bottom: px-em(5,12)

  .options-module_additional-item-fields
    order: 1
    flex-direction: column
    margin-top: 0
    width: 100%
    margin-right: 0

  .options-module_additional-item-field

    + .options-module_additional-item-field
      margin-left: 0
      margin-top: px-em(20)

  .options-module_additional-item-checkbox
    order: 1
    margin-bottom: 4px

    .v-input--selection-controls
      margin-top: 0

    .v-input--selection-controls .v-input__slot > .v-label,
    .v-input--selection-controls .v-radio > .v-label
      display: inline-flex

    .v-messages
      display: none

  .options-module_additional-item-price
    order: 1
    width: 100%
    display: flex
    align-items: baseline
    justify-content: space-between
    padding-top: px-em(20, 12)
    margin-top: px-em(25, 12)
    position: relative

    &::before
      content: ""
      display: block
      position: absolute
      top: 0
      left: 0
      right: 0
      height: px-em(1, 12)
      background-color: #D1D1D1

  .options-module_additional-item-price-value
    font-size: px-em(16, 12)

  .options-module_parking-period,
  .options-module_parking-car-plate
    width: 100%
</style>
